

export const frontMatter = {};
export const contentTitle = undefined;



import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    em: "em",
    li: "li",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsx("p", {
    className: "text-3-col",
    children: _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "a"
        }), " – and, but"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ako"
        }), " – if"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ale"
        }), " – but"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "avto"
        }), " – car"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "bez"
        }), " – without"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "běly"
        }), " – white"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "bliz"
        }), " – almost"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "bolje"
        }), " – more"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "brati"
        }), " – to take"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "byti"
        }), " – to be"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "čaj"
        }), " – tea"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "čas"
        }), " – time"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "časina"
        }), " – hour"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "čest"
        }), " – part"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "člověk"
        }), " – person, human being"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "črěz"
        }), " – through"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "črny"
        }), " – black"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "čto"
        }), " – what"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "da"
        }), " – yes"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dati"
        }), " – to give"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "daže"
        }), " – even"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "denj"
        }), " – day"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dělati"
        }), " – to do, to make"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dělo"
        }), " – act, deed"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "děte"
        }), " – child"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dlja"
        }), " – for"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "do"
        }), " – to, towards, till"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dobro"
        }), " – well"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dobry"
        }), " – good"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dom"
        }), " – house"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dostati"
        }), " – to get, to receive"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "drugy"
        }), " – second"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "država"
        }), " – state"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dva"
        }), " – two"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "dveri"
        }), " – door"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "glas"
        }), " – voice"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "glava"
        }), " – head"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "gleděti"
        }), " – to watch"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "god"
        }), " – year"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "govoriti"
        }), " – to say, to speak"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "grad"
        }), " – city, town"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "groši"
        }), " – money"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "hladny"
        }), " – cold"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "hlěb"
        }), " – bread"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "htěti"
        }), " – to want"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "hvala"
        }), " – thanks"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "i"
        }), " – and"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "idti"
        }), " – to go, to walk"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ih"
        }), " – them; their"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ili"
        }), " – or"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "imati"
        }), " – to have"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "iz"
        }), " – from, out of"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ja"
        }), " – I"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "jedin"
        }), " – one"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "jedino"
        }), " – only"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "jego"
        }), " – him; his"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "jej"
        }), " – her"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "jesti"
        }), " – to eat"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ješče"
        }), " – still"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "k"
        }), " – to, towards"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kaky"
        }), " – what kind of"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kako"
        }), " – how; like"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kava"
        }), " – coffee"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kde"
        }), " – where"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kniga"
        }), " – book"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kogda"
        }), " – when"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "konec"
        }), " – end"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "kto"
        }), " – who"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ktory"
        }), " – which"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "lice"
        }), " – face"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ljubiti"
        }), " – to love, to like"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "maly"
        }), " – little, small"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "maslo"
        }), " – butter"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "medžu"
        }), " – between"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "menje"
        }), " – less"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "meso"
        }), " – meat"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "město"
        }), " – place"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "minuta"
        }), " – minute"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "mlěko"
        }), " – milk"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "mnogo"
        }), " – much; very"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "mogti"
        }), " – can, to be able"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "moj"
        }), " – my"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "može"
        }), " – maybe, perhaps"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "možno"
        }), " – it is possible; possibly"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "muž"
        }), " – man, husband"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "my"
        }), " – we"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "mysliti"
        }), " – to think"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "na"
        }), " – on, upon, at"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "nad"
        }), " – above, beyond"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "najbolje"
        }), " – most"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "naš"
        }), " – our"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ne"
        }), " – no; not"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "nesti"
        }), " – to carry"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "neželi"
        }), " – than"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "něčto"
        }), " – something"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "někaky"
        }), " – some kind of"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "několiko"
        }), " – a few, several"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ni … ni …"
        }), " – neither ... nor ..."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ničto"
        }), " – nothing"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "nikto"
        }), " – nobody"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "noč"
        }), " – night"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "noga"
        }), " – leg"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "novy"
        }), " – new"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "o, ob"
        }), " – about"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "obči"
        }), " – common, general"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "očevidno"
        }), " – of course"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "od"
        }), " – of, from"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "odgovoriti"
        }), " – to answer"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "oko"
        }), " – eye"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "on"
        }), " – he"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ona"
        }), " – she"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "oni"
        }), " – they"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ostati"
        }), " – to stay, to remain"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "otec"
        }), " – father"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "otvoriti"
        }), " – open"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "piti"
        }), " – to drink"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pivo"
        }), " – beer"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "po"
        }), " – after; in the manner of"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "početi"
        }), " – to begin, to start"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pod"
        }), " – under"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pogled"
        }), " – look, sight, view"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pokoj"
        }), " – peace, quiet"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "poslědny"
        }), " – last"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "potom"
        }), " – after that, then"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "potrěbny"
        }), " – needed, necessary"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prěd"
        }), " – before"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pri"
        }), " – by, near"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prijatelj"
        }), " – friend"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prijdti"
        }), " – to come"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prinesti"
        }), " – to bring"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "problem"
        }), " – problem"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prosim"
        }), " – please"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prositi"
        }), " – to ask (for sth.), to require"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prosty"
        }), " – simple, easy"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "prvy"
        }), " – first"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pytanje"
        }), " – question"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "pytati"
        }), " – to ask (a question)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "rabota"
        }), " – work, labour"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "rabotati"
        }), " – to work, to labour"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "raz"
        }), " – time (in the sense of: ... times)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "razuměti"
        }), " – to understand"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "restoran"
        }), " – restaurant"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ruka"
        }), " – arm"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ryba"
        }), " – fish"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "s"
        }), " – with"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "směsta"
        }), " – immediately"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "snova"
        }), " – again"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "sam"
        }), " – alone"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "samo"
        }), " – only, merely"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "se, sebe"
        }), " – oneself"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "seděti"
        }), " – to sit"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "sejčas"
        }), " – now"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "sila"
        }), " – power, force"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "slovo"
        }), " – word"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "slučaj"
        }), " – case, instance, event"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "sok"
        }), " – juice"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "sovsěm"
        }), " – entirely, completely"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "spati"
        }), " – to sleep"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "stary"
        }), " – old"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "stati"
        }), " – to become"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "stati se"
        }), " – to happen"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "stojati"
        }), " – to stand"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "stol"
        }), " – table"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "strana"
        }), " – side"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "svět"
        }), " – world"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "svoj"
        }), " – one's own"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "taky"
        }), " – such"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "tako"
        }), " – so, in such way"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "takože"
        }), " – also, too"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "tamo"
        }), " – there"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "teply"
        }), " – warm"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "to"
        }), " – this, that"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "togda"
        }), " – then"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "toj"
        }), " – this, that"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "toliko"
        }), " – this much, that much, only"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "trěba"
        }), " – it is needed, it is necesary"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "tri"
        }), " – three"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "tu"
        }), " – here"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "tvoj"
        }), " – your (", _jsx(_components.em, {
          children: "sg."
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ty"
        }), " – you (", _jsx(_components.em, {
          children: "sg."
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "uho"
        }), " – ear"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "uže"
        }), " – already"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "v"
        }), " – in; into"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vaš"
        }), " – your (pl.)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "veliky"
        }), " – great, big"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "ves"
        }), " – all, entire"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vid"
        }), " – aspect, look, vision"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "viděti"
        }), " – to see"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vino"
        }), " – wine"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "voda"
        }), " – water"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vojna"
        }), " – war"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vrěme"
        }), " – time"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vsaky"
        }), " – every"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vse"
        }), " – everything"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vsegda"
        }), " – always"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vy"
        }), " – you (", _jsx(_components.em, {
          children: "pl."
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vyjdti"
        }), " – exit, quit"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "vysoky"
        }), " – high"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "za"
        }), " – behind"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "začto"
        }), " – why, what for"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "zato"
        }), " – that's why, therefore"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "zemja"
        }), " – earth, ground"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "zly"
        }), " – bad"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "značiti"
        }), " – to mean"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "znati"
        }), " – to know"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "že"
        }), " – that (conjunction)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "žena"
        }), " – woman, wife"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.em, {
          children: "žiti"
        }), " – to live"]
      }), "\n"]
    })
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

